import type { RequestDetails } from ':shared/interfaces';

import { RequestLocalStorageKey } from ':shared/enums';

export const getRequestDetailsFromLocalStorage = (key: RequestLocalStorageKey): RequestDetails => {
    let requestCount = 0;
    let lastUpdatedAt: number = Date.now();

    const requestDetails = localStorage.getItem(key);
    if (!requestDetails) {
        localStorage.setItem(
            RequestLocalStorageKey.GET_PLACE_DETAILS_REQUEST,
            JSON.stringify({
                requestCount: 0,
                lastUpdatedAt: Date.now(),
            })
        );
    } else {
        const details = JSON.parse(requestDetails);
        requestCount = details.requestCount;
        lastUpdatedAt = details.lastUpdatedAt;
    }
    return {
        requestCount,
        lastUpdatedAt,
    };
};
